module.exports = __webpack_public_path__ + "img/MG-HIW-IMAGES.f06d1fc8.png";